module.exports = __webpack_public_path__ + "static/media/icon-referral.05b2b822.svg";